module.exports = __webpack_public_path__ + "img/UM.90d29f3f.png";